import { useTranslation } from 'react-i18next'
import { useScrollReveal } from '@/hooks/use-scroll-reveal'
import Container from '@/components/ui/container'
import Link from '@/components/ui/link'

export default function AboutCta() {
  const { t } = useTranslation()
  const { ref, visible } = useScrollReveal()

  return (
    <section ref={ref} className="py-16 md:py-24 lg:py-32">
      <Container>
        <div
          className={`relative overflow-hidden py-12 md:py-16 lg:py-20 px-5 sm:px-8 md:px-10 lg:px-12 text-center transition-all duration-700 ease-out ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="absolute inset-0 gradient-cta opacity-10" />
          <div className="absolute inset-0 border border-primary/20" />

          <div className="relative z-10 max-w-2xl mx-auto">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter uppercase text-on-surface mb-6">
              {t('about.cta.heading')}
            </h2>
            <p className="text-on-surface-variant text-lg mb-10">{t('about.cta.description')}</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                href="/contact"
                className="bg-primary text-on-primary px-10 py-4 font-bold uppercase tracking-widest text-sm hover:bg-primary-fixed transition-colors cursor-pointer"
              >
                {t('about.cta.primaryButton')}
              </Link>
              <Link
                href="/cases"
                className="border border-outline-variant/40 hover:border-primary/60 text-on-surface px-10 py-4 font-bold uppercase tracking-widest text-sm transition-colors cursor-pointer"
              >
                {t('about.cta.secondaryButton')}
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
